export const VERT = 0;
export const NORTH = 0;
export const EAST = 90;
export const SOUTH = 180;
export const WEST = 270;

export const HEADINGS = {
  Vert: VERT,
  North: NORTH,
  East: EAST,
  South: SOUTH,
  West: WEST
};

export const TILE_SIZES = {
  North: [256, 192],
  East: [192, 256],
  South: [256, 192],
  West: [192, 256],
  Vertical: [256, 256]
};
